import { useSyncExternalStore } from 'react'

/**
 * 监听页面可见性变化的自定义hook（使用 useSyncExternalStore 优化）
 * 返回当前页面的可见性状态
 */
export function usePageVisibility() {
  // 使用 useSyncExternalStore 订阅页面可见性变化
  const isVisible = useSyncExternalStore(
    // 订阅函数：添加事件监听器并返回清理函数
    onStoreChange => {
      // 处理页面可见性变化的函数
      const handleVisibilityChange = () => {
        onStoreChange()
      }

      // 处理页面焦点变化的函数
      const handleFocus = () => {
        onStoreChange()
      }

      // 处理页面失去焦点的函数
      const handleBlur = () => {
        onStoreChange()
      }

      // 添加事件监听器
      document.addEventListener('visibilitychange', handleVisibilityChange)
      // window.addEventListener('focus', handleFocus)
      // window.addEventListener('blur', handleBlur)

      // 返回清理函数：移除事件监听器
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange)
        window.removeEventListener('focus', handleFocus)
        window.removeEventListener('blur', handleBlur)
      }
    },
    // 获取当前快照：当前页面可见性状态
    () => document.visibilityState === 'visible',
    // 服务器端快照：默认返回可见状态（服务器端无浏览器环境）
    () => true,
  )

  return isVisible
}
